import React from 'react';

import * as S from './cancellation-reschedule-policy-overlay.styles';
import { ModalWindow, Modal } from '../../dweb-common.styles';

import CancellationAndReschedulePolicyUI from './cancellation-and-reschedule-policy-ui';

import { CANCELLATION_ID, DATE_CHANGE_ID } from '@stencil/flights-constants';

import CancellationrescheduleTabs from './cancellation-reschedule-tabs';
import { SpinnerLoader } from '../../common-elements.styles';

const CancellationRescheduleTabView = ({
  error = '',
  activePolicySection,
  setShowPoliciesOverlay,
  fareRulesPolicies,
  logCancellationAndRescheduleDetails,
  showNote = true
}) => {
  if (error && !fareRulesPolicies) {
    return (
      <div className="dF padT20 padB20 alignItemsCenter justifyCenter">
        <p>{error}</p>
      </div>
    );
  }

  if (!fareRulesPolicies) {
    return (
      <div className="padT20">
        <SpinnerLoader />
      </div>
    );
  }

  const isCancellationTabActive = activePolicySection === CANCELLATION_ID;
  const cancellationPolicies = fareRulesPolicies?.find(fareRule => fareRule.id === CANCELLATION_ID);
  const reschedulePolicies = fareRulesPolicies?.find(fareRule => fareRule.id === DATE_CHANGE_ID);
  const policies = isCancellationTabActive ? cancellationPolicies : reschedulePolicies;

  const tabClickHandler = id => {
    const isCancellationTabClicked = id === CANCELLATION_ID;
    const action_name = `${id}_tab_clicked`;
    logCancellationAndRescheduleDetails(
      action_name,
      isCancellationTabClicked
        ? cancellationPolicies?.penalty_cta?.a
        : reschedulePolicies?.penalty_cta?.a
    );
    setShowPoliciesOverlay(id);
  };

  return (
    <>
      <CancellationrescheduleTabs
        hasCancellationData={!!cancellationPolicies}
        hasRescheduleData={!!reschedulePolicies}
        tabClickHandler={tabClickHandler}
        activePolicySection={activePolicySection}
      />
      <CancellationAndReschedulePolicyUI policies={policies} showNote={showNote} />
    </>
  );
};

export default CancellationRescheduleTabView;
